<script>
import auth_api from "@/store/Auth_API.js";
export default {
  namespaced: true,
  state: {
    uid: ""
  },
  mutations: {
    set(state, login_UID) {
      state.uid = login_UID;
    }
  },
  getters: {
    get(state) {
      return state.uid;
    }
  },
  actions: {
    // @return uid or ""
    set_User({ commit }) {
      return new Promise((resolve, reject) => {
        auth_api.get_Login_Status().then(
          user => {
            commit("set", user.uid);
            resolve();
          },
          () => {
            reject();
          }
        );
      });
    },
    remove_User({ commit }) {
      auth_api.logout();

      commit("set", "");

      vm.$router.push({
        name: "Login"
      });
    }
  }
};
</script>
